__turbopack_context__.v({
  "allTopicsLink": "NavigationCategoriesList-module-scss-module__2Uqu0W__allTopicsLink" + " " + "NavigationCategoriesList-module-scss-module__2Uqu0W__categoryLink",
  "categoryLink": "NavigationCategoriesList-module-scss-module__2Uqu0W__categoryLink",
  "item": "NavigationCategoriesList-module-scss-module__2Uqu0W__item",
  "list": "NavigationCategoriesList-module-scss-module__2Uqu0W__list",
});
